import { Box, Divider } from '@mui/material'
import { FC } from 'react'
import { useTheme } from '@cellectenergy/cellect-react-components'

interface SpacerProps {
  bgColor?: string
  width?: string | { xs?: string; md?: string; lg?: string; xl?: string }
  height?: string
  spacerDisplay?: string
  maxWidth?: string
  sx?: object
  fullWidth?: boolean // New prop to allow full width override
}

export const Spacer: FC<SpacerProps> = ({ bgColor, width, height, spacerDisplay, maxWidth, sx, fullWidth }) => {
  const theme = useTheme()

  // If fullWidth is true and width includes 'vw', we need to break out of container constraints
  const needsFullWidthBreakout = fullWidth && width && width.toString().includes('vw')

  if (needsFullWidthBreakout) {
    return (
      <Box
        sx={{
          position: 'relative',
          width: '100vw',
          left: '50%',
          right: '50%',
          marginLeft: '-50vw',
          marginRight: '-50vw',
          backgroundColor: bgColor ? bgColor : theme.palette.common.corporateColors.secondary.turquoise,
          height: height ? height : '1px',
          ...sx,
        }}
      />
    )
  }

  return (
    <Box bgcolor={theme.palette.common.corporateColors.primary.midNightBlue} sx={sx}>
      <Divider
        sx={{
          backgroundColor: bgColor ? bgColor : theme.palette.common.corporateColors.secondary.turquoise,
          width: width ? width : '100%',
          height: height ? height : '1px',
          margin: '0 auto',
          display: spacerDisplay ? spacerDisplay : 'flex',
          maxWidth: maxWidth ? maxWidth : '100%',
        }}
      />
    </Box>
  )
}
